import React from 'react';

import { useIntl } from '../../util/reactIntl';

import { BackButton, FavoriteButton, PartnerPhotoMark } from '../../components';

import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import ShareButton from './ShareListing/ShareButton';
import { listingShareProps } from './ShareListing/shareProps';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const {
    listing,
    author,
    variantPrefix,
    listingFields,
    marketplaceRootURL,
    facebookAppId,
    onManageDisableScrolling,
  } = props;
  const intl = useIntl();
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  // Thumbnails use the same uncropped `scaled-*` variants as the main image
  // (imgix `fit=clip`) and are cropped to a square by CSS `object-fit: cover`,
  // which crops from the centre. The `${variantPrefix}` variants are built
  // with `crop=edges` (edge detection) and came out visibly off-centre.
  const thumbnailVariants = ['scaled-small', 'scaled-medium'];
  return (
    <>
      {/* Phones only: the bottom nav is hidden on a listing, so this is the way
          back to the results, profile or favourites the visitor came from. It
          sits above the photo (Guro, 10 October), so the photo's corners are
          free for the Z, share and heart. */}
      <div className={css.galleryTopBar}>
        <BackButton className={css.galleryBack} />
      </div>
      <section className={css.productGallery} data-testid="carousel">
        <ListingImageGallery
          images={images}
          listing={listing}
          imageVariants={imageVariants}
          thumbnailVariants={thumbnailVariants}
        />
        {/* Guro's Z on a verified partner's photo: top-left, level with the
          share and heart. */}
        <PartnerPhotoMark user={author} className={css.galleryPartnerMark} />
        {/* Share and heart float together in the photo's top-right corner, each
          on its own soft disc. ShareButton renders nothing for unpublished
          listings. */}
        <div className={css.galleryActions}>
          <ShareButton
            {...listingShareProps({ listing, listingFields, marketplaceRootURL, intl })}
            facebookAppId={facebookAppId}
            onManageDisableScrolling={onManageDisableScrolling}
            className={css.galleryAction}
          />
          {listing.id ? (
            <FavoriteButton listingId={listing.id} className={css.galleryAction} />
          ) : null}
        </div>
      </section>
    </>
  );
};

export default SectionGallery;
